// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const zygarde_50_power_construct: PokeData = {
  "id": 10119,
  "name": "zygarde-50-power-construct",
  "height": 50,
  "weight": 3050,
  "base_experience": 300,
  "types": [
    PokeType.DRAGON,
    PokeType.GROUND
  ],
  "api_moves": [
    "bind",
    "bite",
    "earthquake",
    "dig",
    "haze",
    "glare",
    "outrage",
    "sandstorm",
    "safeguard",
    "dragon-breath",
    "crunch",
    "camouflage",
    "dragon-pulse",
    "coil",
    "bulldoze",
    "thousand-arrows",
    "thousand-waves",
    "lands-wrath",
    "core-enforcer"
  ],
  "moves": [
    "bite",
    "earthquake",
    "outrage",
    "sandstorm",
    "dragon-breath",
    "crunch",
    "dragon-pulse",
    "mud-shot",
    "magnitude",
    "bonemerang",
    "draco-meteor",
    "mud-slap",
    "fissure"
  ],
  "evolution_chain": {
    "id": 370,
    "item": null,
    "species": [
      {
        "name": "zygarde",
        "order": 718,
        "types": [
          PokeType.DRAGON,
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 143,
    "speed": 125,
    "ability_power": 132
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
